// import hooks
import { useQuery } from 'react-query';

// import types
import { useGetDutyLinesAuditProps } from './useGetDutyLinesAudit.types';

// import queries & mutations
import { getDutyLinesPeriodsAudit } from 'RestAPIs/employees/hours-table';

const useGetDutyLinesPeriodsAudit = (
  { employeeId, requestId }: useGetDutyLinesAuditProps,
  options: Record<string, any> = {}
) => {
  const enabled = !!requestId && (options as any).enabled !== false;

  return useQuery(
    ['dutyHistoryPeriodsAudit', employeeId, requestId],
    async () => {
      if (requestId === undefined) return null;
      const { data } = await getDutyLinesPeriodsAudit({
        employeeId,
        requestId
      });
      return data;
    },
    { ...options, enabled }
  );
};

export default useGetDutyLinesPeriodsAudit;
